import styled from "styled-components";
import { CSSVars } from "../../styles/styles.config";

export const StyledEmbedPricing = styled.div`
	min-height: 800px;
	padding-top: 80px;
  
	iframe {
		width: 100% !important;
		min-height: 880px !important;
	}
`;

export const StyledPricing = styled.section`
  color: ${CSSVars.black};
  text-align: center;
  min-height: 600px;
	padding: 10px 20px 50px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 20px 40px 100px;
	}
`;
